var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreencheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "greencheck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "greencheck"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_656",
    fill: "#009081",
    fillRule: "nonzero",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "whitecheck",
    stroke: "#FFFFFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "8 14.9341439 12.856908 20 22.4444444 10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.553156c5aec61cce8f1e4a8271c81f45.svg";
export { ForwardRef as ReactComponent };